import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopupComponent } from './popup/popup.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [PopupComponent],
  exports: [PopupComponent],
})
export class PopupModule { }
